import { FormattedMessage, InjectedIntl, MessageValue } from 'react-intl';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

class ValidationErrors {
    public static FIELD_INVALID = 'error.field_invalid';
    public static FIELD_REQUIRED = 'error.field_required';
    public static FIELD_LONG = 'error.long_field_n';
    public static FIELD_SHORT = 'error.short_field_n';

    public static BANCHI_REQUIRED = 'error.banchi_required';
    public static BANCHI_WARNING = 'error.banchi_warning';

    public static fieldInvalidMessage(
        intl: InjectedIntl,
        labelId: string,
        labelValues?: { [key: string]: MessageValue },
    ) {
        const fieldName = intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(labelId),
            labelValues,
        );

        return intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_INVALID),
            {
                fieldName: fieldName ? fieldName.toLowerCase() : '',
            },
        );
    }

    public static fieldRequiredMessage(
        intl: InjectedIntl,
        labelId: string,
        labelValues?: { [key: string]: MessageValue },
    ) {
        const fieldName = intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(labelId),
            labelValues,
        );

        return intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_REQUIRED),
            {
                fieldName,
            },
        );
    }

    public static fieldTooLongMessage(intl: InjectedIntl, maxChar: number) {
        return intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_LONG),
            {
                n: maxChar,
            },
        );
    }

    public static fieldTooShortMessage(intl: InjectedIntl, minChar: number) {
        return intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_SHORT),
            {
                n: minChar,
            },
        );
    }

    public static fieldInvalidMessageProps(
        labelId: string,
        labelValues?: { [key: string]: MessageValue },
    ) {
        return {
            ...TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_INVALID),
            values: {
                fieldName: TranslationHelpers.getFormattedMessage(labelId),
                ...labelValues,
            },
        };
    }

    public static fieldRequiredMessageProps(
        labelId: string,
        labelValues?: { [key: string]: MessageValue },
    ): FormattedMessage.Props {
        return {
            ...TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_REQUIRED),
            values: {
                fieldName: TranslationHelpers.getFormattedMessage(labelId),
                ...labelValues,
            },
        };
    }

    public static fieldTooLongMessageProps(maxChar: number): FormattedMessage.Props {
        return {
            ...TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_LONG),
            values: {
                n: maxChar,
            },
        };
    }

    public static fieldTooShortMessageProps(minChar: number): FormattedMessage.Props {
        return {
            ...TranslationHelpers.getMessageDescriptor(ValidationErrors.FIELD_SHORT),
            values: {
                n: minChar,
            },
        };
    }

    public static banchiRequiredMessage(intl: InjectedIntl) {
        return intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(ValidationErrors.BANCHI_REQUIRED),
        );
    }

    public static banchiWarningMessage(intl: InjectedIntl) {
        return intl.formatMessage(
            TranslationHelpers.getMessageDescriptor(ValidationErrors.BANCHI_WARNING),
        );
    }
}

export default ValidationErrors;
